var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.42627 45.5862C0.42627 54.5136 3.06455 63.2406 8.00747 70.6635C12.9504 78.0864 19.976 83.8718 28.1958 87.2882C36.4156 90.7046 45.4604 91.5984 54.1865 89.8568C62.9125 88.1151 70.9279 83.8162 77.2191 77.5035C83.5103 71.1909 87.7946 63.148 89.5303 54.3921C91.266 45.6362 90.3752 36.5605 86.9705 28.3126C83.5657 20.0648 77.8 13.0152 70.4024 8.05536C63.0047 3.09554 54.3075 0.448242 45.4105 0.448242C33.4799 0.448242 22.038 5.20383 13.6018 13.6688C5.16566 22.1338 0.42627 33.6148 0.42627 45.5862V45.5862ZM19.7052 42.362H58.7451L40.8157 24.2843L45.4105 19.7931L71.1157 45.5862L45.4105 71.3793L40.8157 66.7784L58.7451 48.8103H19.7052V42.362Z",
    fill: "#937356"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.79ef9ce8024535fb3adabf2e607c15e2.svg";
export { ForwardRef as ReactComponent };